/**
 * Screen ID enumeration for user preferences
 * Maps screen names to their corresponding IDs
 */
export enum ScreenIdEnum {
  CustomerRecovery = 1,
  VendorRecovery = 2,
  FeaRecoveryEnabled = 3,
  FeaRecoveryDisabled = 4,
  AutoRecoveryConfig = 5
}

/**
 * Screen ID constants for easy access
 */
export const ScreenIds = {
  CustomerRecovery: ScreenIdEnum.CustomerRecovery,
  VendorRecovery: ScreenIdEnum.VendorRecovery,
  FeaRecoveryEnabled: ScreenIdEnum.FeaRecoveryEnabled,
  FeaRecoveryDisabled: ScreenIdEnum.FeaRecoveryDisabled,
  AutoRecoveryConfig: ScreenIdEnum.AutoRecoveryConfig
} as const;
